import Layout from 'components/Layout/Layout'
import TableToolbar from 'components/UserAdminContent/TableToolbar'
import dayjs from 'utils/dayjs'
import React, { Component } from 'react'
import { Modal, } from 'react-bootstrap'
import "./SalesOpportunities.scss"
import colors from "styles/colors.module.scss";
import { tableIcons } from "utils/MaterialTableHelper";
import OpportunitiesTableWrapper from './OpportunitiesTableWrapper'
import Button from 'Button/Button'
import { uepClient } from 'uepClient'
import WithAlert from "hoc/WithAlert";
import { FilterTextName, TableTitle } from 'constants/UserConstants'

const DATE_FORMAT = "DD MMM YYYY hh:mm a";
// FIX: Use toISOString() to produce "Z" suffix instead of "+00:00"
// which prevents the "+" being decoded as a space by the server
const getDefaultRange = () => ({
    startDate: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    endDate: new Date().toISOString()
});

class SalesOpportunities extends Component {
    constructor() {
        super();
        const { startDate, endDate } = getDefaultRange();
        this.state = {
            isLoading: false,
            opportunities: [],
            selectedRows: [],
            searchText: "",
            showPopUp: false,
            opportunityDetails: {},
            isEditMode: false,
            startDate: startDate,
            endDate: endDate
        }
    }

    componentDidMount() {
        this.fetchAllOpportunities(this.state.startDate, this.state.endDate)
    }

    // Fetching opportunities data from api
    fetchAllOpportunities = (startDate, endDate) => {
        this.setState({ isLoading: true });

        uepClient()
            .get(`/opportunity-cv?startDateTime=${encodeURIComponent(startDate)}&endDateTime=${encodeURIComponent(endDate)}`)
            .then((res) => {
                this.setState({
                    opportunities: res.data,
                    isLoading: false,
                });
            })
            .catch((err) => {
                console.error(`Failed to fetch list of opportunity : ${err}`);
                // Resetting to default state
                this.setState({
                    opportunities: [],
                    isLoading: false,
                });
                this.props.showAlert({
                    variant: "danger",
                    content: (
                        <span>
                            <b>Error!</b> Failed to fetch the list of opportunities, please try again.
                        </span>
                    ),
                });
            });
    };

    // Display Detail single Opportunity in detail
    renderOpportunity = () => {
        const { opportunityDetails } = this.state

        return (
            <div className='seles-op-card'>
                <div className='user-detail-card'>
                    <div className='flex-card'>
                        <div className='user-detail'>
                            <label>Opty Id : </label>
                            <span>{opportunityDetails.optyId ? opportunityDetails.optyId : "NA"}  </span>
                        </div>
                        <div className='user-detail'>
                            <label>Opty Stage : </label>
                            <span>{opportunityDetails.optyStage ? opportunityDetails.optyStage : "NA"}</span>
                        </div>
                    </div>
                    <div className='flex-card'>
                        <div className='user-detail'>
                            <label>Customer Type : </label>
                            <span>{opportunityDetails.customerType ? opportunityDetails.customerType : "NA"}</span>
                        </div>
                        <div className='user-detail'>
                            <label>Channel : </label>
                            <span>{opportunityDetails.channel ? opportunityDetails.channel : "NA"}</span>
                        </div>
                    </div>
                    <div className='flex-card'>
                        <div className='user-detail'>
                            <label>Name : </label>
                            <span>{opportunityDetails.primaryContactFirstName ? opportunityDetails.primaryContactFirstName : "NA"}
                                {opportunityDetails.primaryContactLastName ? opportunityDetails.primaryContactLastName : "NA"}</span>
                        </div>
                        <div className='user-detail'>
                            <label>Contact : </label>
                            <span>{opportunityDetails.primaryContactphoneNumber ? opportunityDetails.primaryContactphoneNumber : "NA"}</span>
                        </div>
                    </div>
                    <div className='flex-card'>
                        <div className='user-detail'>
                            <label>Pl : </label>
                            <span>{opportunityDetails.pl ? opportunityDetails.pl : "NA"}</span>
                        </div>
                        <div className='user-detail'>
                            <label>Lob : </label>
                            <span>{opportunityDetails.lob ? opportunityDetails.lob : "NA"}</span>
                        </div>
                    </div>
                    <div className='flex-card'>
                        <div className='user-detail'>
                            <label>Vehicle Description : </label>
                            <span>{opportunityDetails.vehicleDescription ? opportunityDetails.vehicleDescription : "NA"}</span>
                        </div>
                    </div>
                    <div className='flex-card'>
                        <div className='user-detail'>
                            <label>Sales City : </label>
                            <span>{opportunityDetails.salesCity ? opportunityDetails.salesCity : "NA"} </span>
                        </div>
                        <div className='user-detail'>
                            <label>Sales State : </label>
                            <span>{opportunityDetails.salesState ? opportunityDetails.salesState : "NA"}</span>
                        </div>
                    </div>
                    <div className='flex-card'>
                        <div className='user-detail'>
                            <label>Dealer Code : </label>
                            <span>{opportunityDetails.dealerCode ? opportunityDetails.dealerCode : "NA"}</span>
                        </div>
                        <div className='user-detail'>
                            <label>Org State : </label>
                            <span>{opportunityDetails.orgState ? opportunityDetails.orgState : "NA"}</span>
                        </div>
                    </div>
                    <div className='flex-card'>
                        <div className='user-detail'>
                            <label>Org Name : </label>
                            <span>{opportunityDetails.orgName ? opportunityDetails.orgName : "NA"}</span>
                        </div>
                    </div>
                    <div className='flex-card'>
                        <div className='user-detail'>
                            <label>Lead Name : </label>
                            <span>{opportunityDetails.leadFirstName ? opportunityDetails.leadFirstName : "NA"}
                                {opportunityDetails.leadLastName ? opportunityDetails.leadLastName : "NA"} </span>
                        </div>
                        <div className='user-detail'>
                            <label>Lead Phone Number : </label>
                            <span>{opportunityDetails.leadPhoneNumber ? opportunityDetails.leadPhoneNumber : "NA"}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <Button
                        className="form-cancel-btn cancel-btn close-opty"
                        label="Close"
                        onClick={this.isModalClose}
                    />
                </div>
            </div>
        )
    }

    render() {
        const { isLoading, showPopUp } = this.state;

        return (
            <Layout className="sales-op-dashboard-page">
                <div className="admin-content">
                    <div className="admin-list-table-container">
                        <div className="table-wrapper">
                            {this.renderTableToolbar()}
                            <OpportunitiesTableWrapper
                                icons={tableIcons}
                                columns={this.getTableColumns()}
                                data={this.getOpportunitiesData()}
                                isLoading={isLoading}
                                emptyMessage="No Opportunities found."
                                isModalOpen={this.isModalOpen}
                            />
                        </div>
                    </div>
                    <Modal
                        className="add-brochure-modal"
                        centered
                        onHide={this.isModalClose}
                        show={showPopUp}
                    >
                        {this.renderOpportunity()}
                    </Modal>
                </div>

            </Layout>
        )
    };

    // Rendering table toolbar
    renderTableToolbar = () => {
        const { startDate, endDate, searchText } = this.state
        return (
            <TableToolbar
                searchValue={searchText}
                onSearchTextChange={this.onSearchTextChange}
                onDateChage={this.onDateChage}
                startDate={startDate}
                endDate={endDate}
                onRefreshClick={this.onRefreshClick}
                isButton={false}
                onRecentOpty={this.onRecentOpty}
                filterButtonText={FilterTextName.RecentOpty}
                title={TableTitle.SalesOp}
            />
        );
    };

    // Defining opportunities table format
    getTableColumns = () => {
        const tableColumns = [
            {
                title: "Opty Id",
                field: "opportunityId",
                filtering: false,
                sorting: true,
            },
            {
                title: "Phone Number",
                field: "phoneNumber",
                filtering: true,
            },
            {
                title: "Created Date",
                field: "dateTime",
                defaultSort: "desc",
                render: (rowData) => {
                    return dayjs(rowData.dateTime).format(DATE_FORMAT)
                },
            },
            {
                title: "View Opty",
                filtering: false,
                sorting: false,
                render: rowData => <Button
                    className="view-opty-btn"
                    label="View"
                    onClick={() => this.isModalOpen(rowData)}
                />
            },
        ];

        const tableColumnsWithStyle = tableColumns.map((tc) => ({
            ...tc,
            cellStyle: {
                border: 0,
                color: colors.darkGrey,
                fontWeight: "normal",
            },
            headerStyle: {
                border: 0,
                color: colors.darkGrey,
                fontWeight: "500",
                fontSize: "1em",
            },
        }));
        return tableColumnsWithStyle;
    };

    // Getting search value form table tool bar
    onSearchTextChange = (searchText) => {
        this.setState({
            searchText,
        });
    };

    // Returning all OpportunitiesData
    getOpportunitiesData = () => {
        const { opportunities, searchText } = this.state;
        return searchText.trim().length
            ? opportunities.filter((row) => this.validateSearch(row))
            : opportunities;
    };

    // Validating Search data with OpportunitiesData if it is present or not
    validateSearch = (row) => {
        const { searchText } = this.state;
        const searchLc = searchText.toLowerCase();
        const optyIdValidator = row.opportunityId.toLowerCase().includes(searchLc);
        const phoneNumberValidator = row.phoneNumber.toLowerCase().includes(searchLc);
        const dateValidator =
            dayjs(row.dateTime)
                .format(DATE_FORMAT)
                .toString()
                .toLowerCase()
                .includes(searchLc)
        return (optyIdValidator || phoneNumberValidator || dateValidator);
    };

    // FIX: Use toISOString() to produce "Z" suffix instead of moment's "+00:00"
    // Fetch new Opportunities as per new date
    onDateChage = (date) => {
        const changeStartDate = date.startDate ? new Date(date.startDate).toISOString() : this.state.startDate;
        let changeEndDate = date.endDate ? new Date(date.endDate).toISOString() : this.state.endDate;
        // Keep the range valid: end date can't be earlier than the start date
        if (new Date(changeEndDate) < new Date(changeStartDate)) {
            changeEndDate = changeStartDate;
        }
        this.setState({
            startDate: changeStartDate,
            endDate: changeEndDate
        });
        this.fetchAllOpportunities(changeStartDate, changeEndDate);
    }

    // FIX: Use toISOString() to produce "Z" suffix instead of moment's "+00:00"
    // Fetch recent (last 30 min) Opportunities
    onRecentOpty = () => {
        const { startDate, endDate } = getDefaultRange();
        this.setState({
            startDate: startDate,
            endDate: endDate
        });
        this.fetchAllOpportunities(startDate, endDate)
    }

    // Fetch selected Opportunity and display on PopUp modal
    isModalOpen = (item) => {
        uepClient()
            .post(`/opportunity-cv/details`, {
                optyIds: [
                    item.opportunityId
                ]
            })
            .then((res) => {
                this.setState({
                    showPopUp: true,
                    opportunityDetails: {
                        ...res.data.optyDetails[0],
                        primaryContactphoneNumber: item.phoneNumber
                    },
                })
            })
            .catch((error) => {
                this.props.showAlert({
                    variant: "danger",
                    content: (
                        <span>
                            <b>Error!</b> Failed to fetch opportunity detail.
                        </span>
                    ),
                });
                console.error(
                    `Some error occured while trying to fetch opportunity detail `,
                    error.message
                );
            });
    }

    // Close Popup modal
    isModalClose = () => {
        this.setState({
            showPopUp: false,
            opportunityDetails: {}
        })
    }

    // Clear all filters and Fetch new Opportunities data
    onRefreshClick = () => {
        const { startDate, endDate } = this.state
        this.setState({
            searchText: "",
        })
        this.fetchAllOpportunities(startDate, endDate)
    }

}

const UserSalesOpportunities = WithAlert(SalesOpportunities);

export default UserSalesOpportunities;